








import { Component, Prop, Vue } from "vue-property-decorator";
import ShopMenuItemServiceBase from "./ShopMenuItemServiceBase.vue";
import { Service, ServicePackage } from "@/api/types";

@Component({
  components: {
    ShopMenuItemServiceBase
  }
})
export default class ShopMenuItemServiceSinglePackage extends Vue {
  @Prop() private service!: Service;
  @Prop({ default: "€" }) private currency!: string;
  @Prop({ default: false }) private selected!: boolean;

  get servicePackages(): ServicePackage[] {
    return Object.values(this.service.packages);
  }

  get durations(): number {
    return this.service.duration;
  }

  get durationText(): string | null {
    const { hideDurations, duration } = this.service;
    if (hideDurations) return null;

    return `${duration} min`;
  }

  get prices(): number[] {
    return this.servicePackages.map(servicePackage => servicePackage.price);
  }

  get minPrice(): number {
    return Math.min(...this.prices);
  }

  get maxPrice(): number {
    return Math.max(...this.prices);
  }

  get priceText() {
    const { currency, minPrice, maxPrice } = this;
    if (minPrice < maxPrice)
      return `${currency}${minPrice} - ${currency}${maxPrice}`;
    return `${currency}${minPrice}`;
  }
}
